module.exports = __webpack_public_path__ + "static/media/chip.b73ec0c0.jpg";